import { render, staticRenderFns } from "./qqPopupComponent.vue?vue&type=template&id=fed40222&scoped=true&"
import script from "./qqPopupComponent.vue?vue&type=script&lang=js&"
export * from "./qqPopupComponent.vue?vue&type=script&lang=js&"
import style0 from "./qqPopupComponent.vue?vue&type=style&index=0&id=fed40222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed40222",
  null
  
)

export default component.exports